import React, {useContext, useEffect, useState} from 'react';
import img1 from '../../assets/images/test/img1.jpg'
import img2 from '../../assets/images/test/img2.jpg'
import Slider from "react-slick";
import {Link} from "react-router-dom";
import {axios} from "../../axios";
import {handleImageUrl} from "../../helpers";
import {LangContext} from "../../App";

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical:true,
    verticalSwiping: true,
    autoplay:true,
    autoplaySpeed: 2000,
    cssEase: "linear"
};

const HomeAbroad = () => {
    const [tours, setTours] = useState([]);
    const lang = useContext(LangContext)

    useEffect(() => {
        axios.get('/en/abroad?main_page=true').then(res => {
            if (res.status === 200) {
                setTours(res.data.tours);
            } else {
                console.error('API response is not an array:', res.data);
            }
        }).catch(error => {
            console.error('Error fetching tours:', error);
        });
    }, []);

    const content = {
        en:{
            pageTitle:'Armenian World',
            text:'Armenian history doesn\'t end at Armenia\'s borders. Follow its traces and discover the cultural, spiritual, and historical presence of Armenians in Europe and far beyond.'
        },
        de:{
            pageTitle:'Armenische Welt',
            text:'Die armenische Geschichte endet nicht an Armeniens Grenzen. Folgen Sie ihren Spuren und entdecken Sie die kulturelle, spirituelle und historische Präsenz der Armenier in Europa und weit darüber hinaus.'
        }
    }

    const {pageTitle,text} = content[lang] || content.en

    return (
        <div className='home-abroad'>
            <div className="center-wrapper">
                <aside className='desc'>
                    <h2>{pageTitle}</h2>
                    <p>
                        {text}
                    </p>
                </aside>
                <aside className="abroad-slider">
                    <Slider {...settings}>
                        {tours.map(e => {
                            if (!e) return null;
                            return (
                                <Link key={e.id} to={`/abroad/${e.id}`}>
                                    <div className='abroad-item'>
                                        <img src={handleImageUrl(e.thumbnail)} alt={e.title}/>
                                        <h3>{e.title}</h3>
                                    </div>
                                </Link>
                            )
                        })}
                    </Slider>
                </aside>
            </div>
        </div>
    );
};

export default HomeAbroad;